import { getEnv } from "config/Config";
import { eaFetch } from "services/common/ApiUtils";


export async function getSourceDataConfigForAccount(accountId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `account/${accountId}/data-hub`,
  );
}

